import * as React from 'react';
import { GraphqlQuery } from 'requestapijs';
import { Loading, Input, Card, Row, Col, Button, Skeleton, Page } from 'sha-el-design';
import { UserDetailNodeConnection, UserDetailNodeEdge } from '../../../schema';
import { Link } from 'react-router-dom';
import '../Common/listPageStyles';
import { userDetailListQuery } from './constant';
import { Inject } from '../../helpers';
import { UserService } from '../../service/userService';
import { Pagination } from '../Common/Pagination';
import { nestedAccess } from 'sha-el-design/lib/helpers';
import { MdArrowBack, MdHome } from "react-icons/md";

export class UserDetailList extends React.Component<{}, State> {
  @Inject userService: UserService;

  constructor(props) {
    super(props);

    this.state = {
      after: '',
      name: '',
    };
  }

  // Was a four-column table whose only affordance was a coloured link in the
  // first cell. A directory of people reads better as cards: the role is the
  // thing you scan for, and the whole card is now the hit target.
  person = (edge: UserDetailNodeEdge) => {
    const node = edge.node;
    const role = (node.userType || '').toString().toLowerCase();
    const name = nestedAccess(node, 'employee', 'name') || 'Unnamed';
    const supervisor = nestedAccess(node.supervisor, 'employee', 'name');
    const initials = name
      .split(' ')
      .filter(Boolean)
      .slice(0, 2)
      .map((w) => w[0].toUpperCase())
      .join('');
    return (
      <Link
        className='cs-person'
        key={node.id}
        to={`/dashboard/user_detail/${node.id}`}
      >
        <span className={`cs-person__avatar cs-person__avatar--${role}`} aria-hidden='true'>
          {initials}
        </span>
        <span className='cs-person__body'>
          <h4 className='cs-person__name'>{name}</h4>
          <p className='cs-person__handle'>@{nestedAccess(node, 'user', 'username')}</p>
          {supervisor ? <p className='cs-person__reports'>Reports to {supervisor}</p> : null}
        </span>
        <span className={`cs-person__role cs-person__role--${role}`}>{node.userType}</span>
      </Link>
    );
  }

  breadcrumbs = () => ({
    seperator: "/",
    paths: [
      { text: <MdHome />, link: "/dashboard" },
      { text: "User Detail", link: "/dashboard/user_detail" }
    ].map(v => ({
      render: () => (
        <Link key={v.link} to={v.link}>
          {v.text}
        </Link>
      )
    }))
  });

  render() {
    return (
      <div>
        <Skeleton
          isLoading={false}
          render={() => (
            <Page
            title={"User Detail List"}
            breadcrumbs={this.breadcrumbs()}
            backIcon={
            <Link to={"/dashboard"}>
              <MdArrowBack />
            </Link>
          }
          extra={
            <Row>
              <Col offset={12} span={10}>
                <span className='cs-list__action'>
                  <Link to='/dashboard/user_detail/add'>
                    <Button style={{ width: '100%' }} type='primary' >Add User Detail</Button>
                  </Link>
                </span>
              </Col>
            </Row>
          }
        >
            <Card>
              {[
                // Was a floated div with a hardcoded 300px width, which
                // collided with the content below on narrow viewports.
                <div className='cs-list__filters' key='search'>
                  <div className='cs-list__filter'>
                    <Input
                      placeholder='Search by name'
                      value={this.state.name}
                      onChange={(e) => this.setState({ name: e.target.value })}
                    />
                  </div>
                </div>,
                <GraphqlQuery
                  key='query'
                  queryString={userDetailListQuery}
                  variables={
                    this.state
                  }
                  render={(response: { allUserDetails: UserDetailNodeConnection }, error, loading) => {
                    if (error) {
                      return <h3>Something went wrong</h3>;
                    }
                    return (
                      <Loading
                        isLoading={loading}
                        render={() => (
                          <div>
                            {response.allUserDetails.edges.length ? (
                              <div className='cs-people'>
                                {response.allUserDetails.edges.map(this.person)}
                              </div>
                            ) : (
                              // An empty table used to render as a bare header
                              // row, indistinguishable from a failed load.
                              <div className='cs-list__empty'>
                                <h4>{this.state.name ? 'No matching users' : 'No users yet'}</h4>
                                <p>
                                  {this.state.name
                                    ? `Nobody matches "${this.state.name}".`
                                    : 'Use Add User Detail to create the first account.'}
                                </p>
                              </div>
                            )}
                            <Pagination
                              endCursor={response.allUserDetails.pageInfo.endCursor}
                              hasNextPage={response.allUserDetails.pageInfo.hasNextPage}
                              after={(after) => this.setState({ after })}
                            />
                          </div>
                        )}
                      />
                    );
                  }}
                />]}
            </Card>
            </Page>
          )}
        />
      </div>
    );
  }
}

interface State {
  after: string;
  name: string;
}
